import { FC, HTMLAttributes } from "react";
import { clsx } from "clsx";
import { getScoreGrade } from "../../../../common/Grade";
import classes from "./VersionMarker.module.less";

interface VersionMarkerProps extends HTMLAttributes<HTMLDivElement> {
    version: number;
    score: number;
    labelPosition?: "above" | "below";
}

export const VersionMarker: FC<VersionMarkerProps> = ({
    version,
    score,
    labelPosition = "above",
    className,
    ...props
}) => {
    return (
        <div className={clsx(className, classes.container)} {...props}>
            <div className={clsx(classes.label, classes[labelPosition])}>
                V{version}: {score}% ({getScoreGrade(score).grade})
            </div>
        </div>
    );
};
